import { Amplify } from 'aws-amplify'

import amplifyConfiguration from '~/amplifyconfiguration.json'

const authConfig = () => {
  const updatedExports = {
    ...amplifyConfiguration,
    oauth: {
      ...amplifyConfiguration.oauth,
      redirectSignIn: `${window.location.origin}/auth/callback`,
      redirectSignOut: `${window.location.origin}/auth/signout`,
    },
  }

  Amplify.configure(updatedExports)
}

export default authConfig
